import { render, staticRenderFns } from "./SuggestProductCard.vue?vue&type=template&id=0202fa22&scoped=true&"
import script from "./SuggestProductCard.vue?vue&type=script&lang=js&"
export * from "./SuggestProductCard.vue?vue&type=script&lang=js&"
import style0 from "./SuggestProductCard.vue?vue&type=style&index=0&id=0202fa22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0202fa22",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
